import { IGetComparisonDesktopResponse } from '../../repositories/offers-comparison/v2/get-comparison-desktop';
import { ICompare } from '../../services/compare';
import { prepareOffers } from '../prepareOffers';
import { prepareIds } from '../prepareIds';
import { prepareSeoData } from '../prepareSeoData';
import { transformComparisonOffers } from './transformComparisonOffers';
import { TCompareType } from '../../types/compareType';
import { prepareProps } from '../prepareProps';

interface IParameters {
  response: IGetComparisonDesktopResponse;
  compareType: TCompareType;
}

export const prepareComparison = ({ response, compareType }: IParameters): ICompare => {
  const offers = transformComparisonOffers(response);

  return {
    notFoundUrl: response.notFoundUrl,
    offers: prepareOffers(offers),
    ids: prepareIds(offers),
    props: prepareProps(response.props, compareType),
    seoData: prepareSeoData(response.seoData),
  };
};
